<template>
  <page-wrapper :title="title">
    <div class="header" v-if="!$isCallCenter">
      <sc-button class="create-button" variant="primary" :route="createRoute"
        >เพิ่มหมวดหมู่</sc-button
      >
      <sc-button
        class="sort-button"
        variant="secondary"
        :route="{ name: 'ServiceCategorySortPage' }"
        v-if="!$isCallCenter"
        >จัดลำดับ</sc-button
      >
    </div>
    <category-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></category-list-item>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import CategoryListItem from "../components/CategoryListItem";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    CategoryListItem
  },
  data() {
    const title = "หมวดหมู่บริการ";
    const createRoute = { name: "ServiceCategoryCreatePage" };
    const list = [];

    return {
      title,
      list,
      createRoute
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.serviceCategories.list();

      return response.data.result.map(item => {
        return {
          id: item.id,
          name: item.name,
          iconUrl: item.icon,
          route: { name: "ServiceCategoryDetailPage", params: { id: item.id } },
          serviceCount: item.service_ids.length
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/service-categories/pages/ServiceCategoryListPage.vue